import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash-es';
import { fireThankYouTracking } from 'site-modules/shared/components/lead-form/utils/utils';
import { getPhoneNumber } from 'site-modules/shared/components/lead-form/unified-lead-form/components/cards/digital-retail-card-utils';
import { Link } from 'site-modules/shared/components/link/link';
import { INSIDER_PATHS } from 'site-modules/shared/constants/profile/dashboard-paths';
import { toDisplayFormattedAddress } from 'site-modules/shared/utils/address-format';
import { toSlug } from 'site-modules/shared/utils/car-buying/vehicle-util';

export class UserCongratsInfoPriceChecker extends Component {
  static propTypes = {
    customConfig: PropTypes.shape({
      isMobile: PropTypes.bool,
      selectedVehicle: PropTypes.shape({}),
    }),
    leadTargets: PropTypes.arrayOf(PropTypes.shape({})),
    trackingData: PropTypes.shape({}),
  };

  static defaultProps = {
    customConfig: {},
    leadTargets: [],
    trackingData: {},
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    const { leadTargets, trackingData } = this.props;

    fireThankYouTracking({
      leadTargets,
      trackingData,
      target: this.ref.current,
    });
  }

  render() {
    const { isMobile, selectedVehicle } = this.props.customConfig;

    const dealerName = get(selectedVehicle, 'dealerInfo.name');
    const address = get(selectedVehicle, 'dealerInfo.address');
    const { areaCode, prefix, postfix } = getPhoneNumber(get(selectedVehicle, 'dealerInfo.phoneNumbers', {})) || {};
    const { make, model, year } = get(selectedVehicle, 'vehicleInfo.styleInfo', {});
    const makeSlug = make && toSlug(make);
    const modelSlug = model && toSlug(model);
    const priceCheckerPageUrl = `/price-checker/?make=${makeSlug}&model=${modelSlug}&year=${year}`;

    return (
      <div
        ref={this.ref}
        className={classNames('user-congrats-info text-gray-darker', { 'px-1 py-1_5': isMobile })}
        data-test="thank-you-section"
      >
        <div className="text-primary size-20 fw-bold mb-0_5">Success, you’re all set!</div>
        <div className="mb-1_25">Your request has been sent and the dealer should follow up shortly.</div>
        <div className="ps-1_25 mb-1_5">
          <div>
            <b>{dealerName}</b>
          </div>
          <div className="dealer-address">{toDisplayFormattedAddress(address)}</div>
          {areaCode && prefix && postfix && (
            <a className="text-primary" href={`tel:${areaCode}${prefix}${postfix}`}>
              ({areaCode}) {prefix}-{postfix}
            </a>
          )}
        </div>
        <ul className="m-0 ps-2">
          <li>
            We’ve saved this car to your
            <Link
              to={INSIDER_PATHS.INVENTORY_PAGE}
              className="btn btn-link btn-sm text-primary text-transform-none size-16 ps-0_25 pe-0 py-0 insider-link"
              target="_blank"
            >
              dashboard
            </Link>
            !
          </li>
          {makeSlug && modelSlug && year && (
            <li>
              Use the
              <Link
                to={priceCheckerPageUrl}
                className="btn btn-link btn-sm text-primary text-transform-none size-16 px-0_25 py-0 insider-link"
                target="_blank"
              >
                Edmunds Price Checker™
              </Link>
              to compare the dealer’s best price with similar transactions in your area.
            </li>
          )}
        </ul>
      </div>
    );
  }
}
